import Masonry from "masonry-layout";
import onResize from "../utils/onResize";

import { get } from "@bigyouth/base";
import { get as getPipe } from "../utils/sigpipe";

import withResponsive from "../hoc/withResponsive";

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: "masonry-grid",
  timer: 0,

  componentDidMount() {
    this.off = onResize(this.onResize.bind(this));

    const pipeId = this.el.getAttribute("data-grid-pipe-id");
    if (pipeId) {
      this.pipe = getPipe(pipeId);
      this.pipe.on(({ action }) => {
        switch (action) {
          case "grid-populated":
            clearTimeout(this.timer);
            this.winPosY = window.pageYOffset;

            this.timer = setTimeout(_ => {
              this.setupGrid();
              window.scroll(0, this.winPosY);
            }, 800);
            break;

          default:
            console.log("error in action pipe");
            break;
        }
      });
    }

    //window.addEventListener("orientationchange", this.setupGrid)
  },

  componentWillUnmount() {
    if (this.pipe) this.pipe.destroy();
    window.removeEventListener("orientationchange", this.setupGrid);
    if (this.msnry) this.msnry.destroy();
  },

  onResize() {
    this.setupGrid();
  },

  setupGrid() {
    if (window.innerWidth >= 768) {
      if (this.msnry) {
        this.msnry.destroy();
      }
      this.msnry =
        Masonry.data(".js-grid") ||
        new Masonry(".js-grid", {
          itemSelector: ".js-grid-item",
          gutter: 0,
          horizontalOrder: true,
          percentPosition: true,
          columnWidth: 1
        });
      setTimeout(_ => {
        // sinon mauvais calcul à l'init.......
        this.msnry.layout();
      }, 1000);
    } else {
      if (this.msnry) this.msnry.destroy();
    }

    for (let item of this.el.querySelectorAll(".actus-list__item.is-hidden")) {
      item.classList.remove("is-hidden");
    }
  }
};
